<template>
	<div class="delivery__group-input-wrapper">
		<div class="input">
			<label :for="inputId" class="input__label">Вулиця</label>
			<v-select
				v-model="selectedAddress"
				:options="addressOptions"
				label="label"
				:filterable="false"
				:clearable="false"
				@search="onSearch"
				@option:selected="onSelect"
				placeholder="Введи адресу"
			>
				<template #no-options="{ searching, search }">
					<span v-if="searching && search">Вибачте, немає відповідних варіантів</span>
					<span v-else>Почніть вводити адресу</span>
				</template>
			</v-select>
			<div class="input__error" aria-hidden="true"></div>
		</div>
	</div>
</template>

<script setup>
// @ts-nocheck
import { ref, watch } from 'vue';

const props = defineProps({
	inputId: {
		type: String,
		required: true
	},
	modelValue: {
		type: Object,
		default: null
	},
	city: {
		type: Object,
		default: null
	}
});

const emit = defineEmits(['update:modelValue']);

const addressOptions = ref(Array());
const selectedAddress = ref(props.modelValue || null);

const resolveNpConf = () => {
	try {
		if (window['globalConf'] && window['globalNpConf']) {
			return window['globalConf'](window['globalNpConf']);
		}

		if (window['NpConf']) {
			return window['NpConf'];
		}
	} catch (error) {
		console.error('Failed to resolve NP config', error);
	}

	return null;
};

const onSearch = async (query = '') => {
	const term = (query || '').trim();
	if (term.length < 3) {
		addressOptions.value = [];
		return;
	}

	const npConf = resolveNpConf();
	const endpoint = npConf?.url?.getNpStreet;
	const shopName = npConf?.shop_name;
	const cityId = props.city?.city_id || sessionStorage.getItem('city_id');

	if (!endpoint || !shopName || !cityId) {
		addressOptions.value = [];
		return;
	}

	try {
		const response = await fetch(
			`${endpoint}?query=${encodeURIComponent(term)}&shop_name=${encodeURIComponent(shopName)}&city_id=${encodeURIComponent(cityId)}`
		);
		const data = await response.json();
		addressOptions.value = Array.isArray(data) ? data : [];
	} catch (error) {
		console.error('Failed to fetch streets', error);
		addressOptions.value = [];
	}
};

const onSelect = (item = null) => {
	if (!item) {
		return;
	}

	selectedAddress.value = item;
	emit('update:modelValue', item);

	sessionStorage.setItem('np_street', item.value || '');
	sessionStorage.setItem('address_label', item.label || '');
};

watch(() => props.modelValue, (value) => {
	selectedAddress.value = value || null;
});

watch(() => props.city, () => {
	addressOptions.value = [];
	selectedAddress.value = null;
	emit('update:modelValue', null);
	sessionStorage.setItem('np_street', '');
	sessionStorage.setItem('address_label', '');
});
</script>
